app.service('DomainService', ['$http', '$location', function($http, $location) {

    this.getSubdomain = function() {
        return _.split($location.host(), '.')[0];
    };
}]);